import type { MouseEvent } from 'react';
import classNames from '@/external/classNames';
import IconButton from '@/external/components/IconButton';
import GenericStar from '@/external/icons/GenericStar';

type Props = {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  isFavourite?: boolean;
  newThumbsEnabled?: boolean;
  gameId: string;
};

const FavouriteToggleButton: FC<Props> = ({
  onClick,
  isFavourite,
  newThumbsEnabled,
  gameId,
}) => (
  <IconButton
    onClick={onClick}
    className={classNames(
      'p-0 bg-transparent',
      newThumbsEnabled && 'bg-goten w-5 h-5',
    )}
    data-testid="favourite-toggle"
    size="xs"
    key={gameId}
    icon={
      <GenericStar
        className={classNames(
          'text-goten flex-shrink-0 text-moon-32',
          isFavourite ? 'fill-krillin' : 'fill-transparent',
          newThumbsEnabled && 'text-moon-20',
          newThumbsEnabled && !isFavourite && 'fill-popo',
        )}
      />
    }
  />
);

export default FavouriteToggleButton;
